export class PublishInfoRawDto {
  title: string;
  information: string;
  published: boolean;
}
